var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ./~/async-validator/~/core-js/library/modules/_cof.js
// module id = 108
// module chunks = 1